import * as fontRegular from '@fortawesome/free-regular-svg-icons';
import * as fontSolid   from '@fortawesome/free-solid-svg-icons';

export {
    fontRegular,
    fontSolid
};
